import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";
import { trim } from "~/tools/trim";

const DEFAULT = "";

type WidgetMetricLabel = ImpulseFormUnit<string, null, undefined | string>;

function init(initial = DEFAULT): WidgetMetricLabel {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		transform: (input) => trim(input) || undefined,
	});
}

const WidgetMetricLabel = {
	default: DEFAULT,
	init,
} as const;

export { WidgetMetricLabel };
